export default __webpack_public_path__ + "static/whatWeDo2-4554725524245b4172fc0e26b8e8b159.webp";